<template>
	<form @submit.prevent="">
		<div class="form-row">
			<div class="col-12">
				<label for="title">عنوان ویجت</label>
				<input type="text" id="title" placeholder="عنوان ویجت" class="widget-input input-no-bg input-lg input-set-border w-100" v-model="data.title">
			</div>
		</div>

		<div class="form-row">
			<div class="col-12">
				<label for="title">دسته‌بندی خبر</label>
				<!-- <select v-model="data.category_id" class="form-control t-widget-select widget-select-lg select-set-border">
					<option v-for="(category_id, category_title) in categories" :key="category_title" :value="category_title">{{ category_id }}</option>
				</select> -->
				<div class="widget-select w-100 m-top widget-select-lg">
					<v-select v-model="data.category_id" :clearable="false" label="title" :reduce="(option) => option.id" :options="categories">
					</v-select>
				</div>
			</div> 
		</div>

		<div class="form-row text-center mt-4">
			<div class="col-12">
				<a href="" @click.prevent="saveSettings()" class="m-left min-w150 tgju-btn tgju-btn-lg tgju-btn-primary"><i class="uil uil-save"></i> ذخیره</a>
			</div>
		</div>
	</form>
</template>

<script>
	import vSelect from 'vue-select'
	Vue.component('v-select', vSelect);

	export default {
		name: 'SettingsNews',
		components: {},
		props: ['data'],
		data: function () {
			return {
				categories: [
					{
						id: 120,
						title: 'اخبار طلا و سکه'
					},{
						id: 121,
						title: 'اخبار بازار ارز'
					},{
						id: 30143,
						title: 'ارزهای دیجیتال'
					},{
						id: 112,
						title: 'اخبار نفت و انرژی'
					},{
						id: 113,
						title: 'اخبار بورس'
					},{
						id: 114,
						title: 'اخبار مسکن و عمران'
					},{
						id: 115,
						title: 'اخبار خودرو'
					},{
						id: 116,
						title: 'اخبار بانک و بیمه'
					},{
						id: 30148,
						title: 'اخبار تولید'
					},{
						id: 30149,
						title: 'اخبار تجارت'
					},{
						id: 118,
						title: 'اخبار قیمت‌ها'
					},{
						id: 119,
						title: 'اخبار اقتصادی'
					},{
						id: 30145,
						title: 'اخبار جهان'
					},{
						id: 30146,
						title: 'اخبار فناوری'
					}
				],
				// categories: {
				// 	120: 'اخبار طلا و سکه',
				// 	121: 'اخبار بازار ارز',
				// 	30143: 'ارزهای دیجیتال',
				// 	112: 'اخبار نفت و انرژی',
				// 	113: 'اخبار بورس',
				// 	114: 'اخبار مسکن و عمران',
				// 	115: 'اخبار خودرو',
				// 	116: 'اخبار بانک و بیمه',
				// 	30148: 'اخبار تولید',
				// 	30149: 'اخبار تجارت',
				// 	118: 'اخبار قیمت ها',
				// 	119: 'اخبار اقتصادی',
				// 	30145: 'اخبار جهان',
				// 	30146: 'اخبار فناوری',
				// }
			}
		},

		mounted() {

		},

		methods: {
			saveSettings() {
				let data = this.$helpers.unbindObject(this.data);

				this.$parent.saveSettings(data);
				console.log(this.data);
			},
		},
	}
</script>